




import {Component, Prop, Vue} from 'vue-property-decorator';
import {LTileLayer} from 'vue2-leaflet';

@Component({components: {LTileLayer}})
export default class MapyCzOrthoPhotoLayer extends Vue {
    @Prop({type: Boolean, default: true})
    public readonly visible: boolean;
    private apiKey = process.env.VUE_APP_API_KEY_MAPY_CZ;
    public readonly url = 'https://api.mapy.cz/v1/maptiles/aerial/256/{z}/{x}/{y}?apikey=' + this.apiKey;
    public readonly  attribution = '<a href="https://api.mapy.cz/copyright" target="_blank">&copy; Seznam.cz a.s. a další</a>';
}
